import { useObserver } from 'mobx-react';
import { stores } from '~web/store';
import { AuthStore } from '~web/store/auth-store';
import { useStore } from '~web/view/hooks/use-store';

export const useAuthentication = (): boolean => {
  const authStore: AuthStore = useStore<AuthStore>(stores.authStore);
  return useObserver<boolean>(() => authStore.authenticated);
};



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/hooks/use-authentication.ts